import React, { useContext, useMemo } from 'react';
import { OpenTokContext } from '../../../contexts/opentok/opentok-context';

export default function DebugVideo() {
	const { opentok } = useContext(OpenTokContext);

	const streams = useMemo(
		(): string[] => Array.from(opentok?.streams.keys() ?? []),
		[opentok?.streams],
	);

	return (
		<div className="section memory-dashboard">
			<h5>Opentok webrtcIds</h5>
			{streams.map((webrtcid) => <div key={webrtcid}>{webrtcid}</div>)}
		</div>
	);
}
